import './interaction_lock_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['sentence']
  static classes = ['locked']

  connect = (): void => {
    if (this.isMacintosh()) {
      this.sentenceTarget.innerHTML = 'Hold ⌘ while scrolling to zoom'
    } else if (this.isTouchDevice()) {
      this.sentenceTarget.innerHTML = 'Use two fingers to pan'
    } else {
      this.sentenceTarget.innerHTML = 'Hold Ctrl while scrolling to zoom'
    }

    this.element.addEventListener('wheel', event => {
      const { ctrlKey, metaKey } = event
      if (ctrlKey === true || metaKey === true) event.preventDefault()
    })
  }

  lock = (): void => {
    this.element.classList.add(this.lockedClass)
    setTimeout(() => this.unlock(), 1000)
  }

  unlock = (): void => {
    this.element.classList.remove(this.lockedClass)
  }

  isMacintosh = (): boolean => {
    return navigator.platform.includes('Mac')
  }

  isTouchDevice = (): boolean => {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
  }
}
